<div [className]="className" [style]="styleName">
      
      <i [className]="inputClass" [style]="inputStyle" tabindex="0" (keypress)="keyPress($event)"
         (click)="onClick()" role="button" alt-text='button.close'></i>

            <div [className]="labelClass" 
                     [style]="labelStyle" 
                    [translateParams]="labelParam" translate>
                    <span [innerHTML]="label|translate:labelParam"></span>
                    <ng-content></ng-content> 
            </div>
</div>


<!--  glyphicon glyphicon-remove  glyphicon-remove-sign -->